/**
 * @generated SignedSource<<7754502190c9fc986412bf30016d40a0>>
 * @relayHash 1863df8f5b437509db01b53adb690a5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 562db4f12c4ad9eae28ba6c51ae8da8b69fd2ce5bffe3434f22e60bb0283413f

import type { ConcreteRequest } from 'relay-runtime';
export type useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery$variables = Record<PropertyKey, never>;
export type useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery$data = {
  readonly user: {
    readonly confluence: {
      readonly hasPersonalSpace: boolean | null | undefined;
      readonly space: {
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly team: string | null | undefined;
  } | null | undefined;
};
export type useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery = {
  response: useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery$data;
  variables: useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "name": "team"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasPersonalSpace"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1863df8f5b437509db01b53adb690a5e",
    "id": "562db4f12c4ad9eae28ba6c51ae8da8b69fd2ce5bffe3434f22e60bb0283413f",
    "metadata": {},
    "name": "useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery",
    "operationKind": "query",
    "text": "query useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery{user:confluence_atlassianUser(current:true){id,team,confluence{hasPersonalSpace,space{id,key}}}}"
  }
};
})();

(node as any).hash = "c5200736e1bf2cb94aae4951d21860dd";

export default node;
